import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Box } from '@cp/ds/src/components/box';
import { SxProps } from '@mui/material';
import React from 'react';

interface TimePointProps {
  sx?: SxProps;
}

const TimePoint: React.FC<TimePointProps> = ({ sx }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'absolute',
        top: -14,
        transform: 'translateX(-50%)',
        width: 30,
        height: 30,
        background: theme.palette['brand pink'],
        borderRadius: '50%',
        border: `3px ${theme.palette.white} solid`,
        zIndex: 1,
        ...sx,
      }}
    />
  );
};

export default TimePoint;
